module.exports = __webpack_public_path__ + "img/borderTopBottomCornerWhite.7ddb2c27.svg";